import { TranslationCustomerMessages, CustomerMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationCustomerMessages = {
  [CustomerMessages.applicationDashboard]: "Tablero",
  [CustomerMessages.applicationConcretingRequest]: "Solicitud de hormigonado",
  [CustomerMessages.applicationConcretingRequestAbbreviated]: "Solicitud de horm.",
  [CustomerMessages.applicationContract]: "Contratos",
  [CustomerMessages.applicationContractAmounts]: "Importes de contrato",
  [CustomerMessages.applicationConcreting]: "Hormigonados",
  [CustomerMessages.applicationInvoice]: "Facturas",
  [CustomerMessages.applicationConcretingApproval]: "Aprobación de hormigonado",
  [CustomerMessages.applicationCertificate]: "Informes",
  [CustomerMessages.applicationClient]: "Clientes",
  [CustomerMessages.applicationPermission]: "Permisos",
  [CustomerMessages.applicationLogout]: "Cerrar sesión",
  [CustomerMessages.applicationSettings]: "Ajustes",
  [CustomerMessages.allUsersStatusIconTitle]: "All users",
  [CustomerMessages.newUsersStatusIconTitle]: "New users",
  [CustomerMessages.activeUsersStatusIconTitle]: "Usuarios activos",
  [CustomerMessages.inactiveUsersStatusIconTitle]: "Usuarios inactivos",
  [CustomerMessages.blockedUsersStatusIconTitle]: "Usuarios bloqueados",
  [CustomerMessages.inactivedUser]: "Usuario inactivo",
  [CustomerMessages.activedUser]: "Usuario activado",
  [CustomerMessages.errorInactivatingUser]: "Error al inactivar usuario",
  [CustomerMessages.errorActivatingUser]: "error al activar usuario",
  [CustomerMessages.inactivateUserTitle]: "Inactivar usuario",
  [CustomerMessages.activateUserTitle]: "Activar usuario",
  [CustomerMessages.inactivateUserText]: "¿Quieres desactivar el usuario de <USER_NAME>?",
  [CustomerMessages.activateUserText]: "¿Quieres activar el usuario <USER_NAME>?",
  [CustomerMessages.inactivateUserButton]: "Inactivar",
  [CustomerMessages.activateUserButton]: "Activar"
};
